import { sendGetRequest } from '@/services/api.service'
import { API_GMB } from '@/config/api.config'

export const listLocalPosts = (clientId, account, urlParams) => {
  return sendGetRequest(
    `${API_GMB.BASE_API_URL}${API_GMB.LOCAL_POSTS}?clientId=${clientId}&account=${account}${urlParams}&`
  )
}
